import { render, staticRenderFns } from "./CreateTopic.vue?vue&type=template&id=48256ace&"
import script from "./CreateTopic.vue?vue&type=script&lang=js&"
export * from "./CreateTopic.vue?vue&type=script&lang=js&"
import style0 from "./CreateTopic.vue?vue&type=style&index=0&id=48256ace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports